import React, { Component } from "react";
import { Route, BrowserRouter, Switch, withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import Auth from "./containers/Auth/Auth";
/*import Dashboard from './components/Dashboard/Dashboard';*/
import Users from "./containers/User/Users";
import Requests from "./containers/Request/Requests";
import NewRequest from "./containers/Request/NewRequest";
import ClientResponse from "./containers/Request/ClientResponse";
import DocumentList from "./containers/Document/DocumentList";
/*import CompanyList from "./containers/Company/CompanyList";*/
import Settings from "./containers/Settings/Settings";
import User from "./containers/User/User";
import Logout from "./containers/Auth/Logout/Logout";
import Layout from "./hoc/Layout/Layout";
import * as actions from "./store/actions/index";
import RequestList from "./containers/Request/RequestList";
import NewAdminRequest from "./containers/Request/NewAdminRequest";

class App extends Component {
  componentDidMount() {
    this.props.onTryAutoSignup();
  }

  render() {
    let routes = (
      <Switch>
        <Route path="/auth" component={Auth} />
        <Route path="/" exact component={Auth} />
        <Redirect to="/" />
      </Switch>
    );
    if (this.props.isAuthenticated) {
      routes = (
        <Switch>
          
            <Route exact path="/" component={RequestList} />
            <Route exact path="/requestResponse" component={ClientResponse} />
            <Route exact path="/documents" component={DocumentList} />
            <Route exact path="/users" component={Users} />
            <Route exact path="/settings" component={Settings} />
            <Route exact path="/logout" component={Logout} />
            <Route exact path="/account" component={User} />
            <Route path="/requests" component={Requests} />
            <Route path="/request" component={NewRequest} />
            <Route path="/admin_request" component={NewAdminRequest} />
            <Redirect to="/" component={Requests} />
          
        </Switch>
      );
    }

    return <Layout>
      <React.Suspense fallback="Chargement ..">{routes}</React.Suspense>
    </Layout>;
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/App.js